import React from "react";

export const Wordmark = ({ className = "", showDot = true }) => {
  return (
    <span
      className={`inline-flex items-baseline font-serif tracking-tight ${className}`}
      data-testid="brand-wordmark"
    >
      <span className="font-medium">Transformo</span>
      {showDot && (
        <span className="text-brand-accent font-medium">.</span>
      )}
      <span className="text-white/70 text-[0.6em] tracking-[0.18em] uppercase ml-1">
        co.in
      </span>
    </span>
  );
};

export default Wordmark;
